
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
// import { authKey, getLocalStorageItem('id_token')} from '../../common/URLs';

import "./asnGRN.css";
// import { ConfirmPopover } from '../../preregcamps/confirmPopover/confirmPopover';
// import { ErrorPopover } from '../../common/ErrorPopover/errorPopover';
// import { confirmAlert } from 'react-confirm-alert';
// import { loaderService } from "../../common/custom-loader/loader-service";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Table } from 'react-bootstrap';
//import TrashIcon from '../../images/TrashIcon.png';
import { authKey, GET_CONSIGNMENT_STATUS_LIST, GET_ASN_LIST } from '../../../common/URLs';
import Moment from 'moment';
import jwt from 'jwt-decode';
// import { CommonRegistrationSidebar } from "../../common/common-registration-sidebar/commonRegistrationSidebar";
import SearchIcon from "@mui/icons-material/Search";
import moment from 'moment';
import { Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD,PIT_ROLES } from "../../../common/constants";
import { userData } from '../../../common/spinLoader';
import { toast } from 'react-toastify';
import apiClient from "../../../axios";

function AsnGRNChipping() {

    const userLoggedInRole = userData?.user?.userRoles?.[0]?.roleName;
    const navigate = useNavigate();

    const decoded = jwt(getLocalStorageItem('id_token'));
    const [asnDetails, setAsnDetails] = useState([]);
    const [consignmentStatusList, setConsignmentStatusList] = useState();
    const [searchFilter, setSearchFilter] = useState({
        "consignmentStatus": "",
        "schduledDeliveryDate": ""
    });
    useEffect(() => {
        getAsnDetails();
    }, []);

    const onViewDetails = (cellValues) => {
        if (cellValues.row.asnType === "ChipBamboo") {
            navigate('/ChippingAsnGrnViewDetails', {
                state: { selectedRow: cellValues.row }
            });
        } else {
            navigate('/AsnGrnViewDetails', {
                state: { selectedRow: cellValues.row }
            });
        }

    }

    useEffect(() => {
        getConsignmentStatusList();
    }, []);

    const getConsignmentStatusList = () => {
        loaderService.showLoader()
        apiClient
            .post(
                GET_CONSIGNMENT_STATUS_LIST,
                {

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setConsignmentStatusList(response.data.consignmentStatus);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    const getAsnDetails = () => {
        let data = {
            "stakeholderUrn": "plant",
            "stakeholderType": "Plant",
            "consignmentStatus": searchFilter?.consignmentStatus ? searchFilter?.consignmentStatus : null,
            "schduledDeliveryDate": searchFilter?.schduledDeliveryDate ? searchFilter?.schduledDeliveryDate : null

        }

        if (userLoggedInRole ===  PIT_ROLES.ProcessingIncharge  || userLoggedInRole ===  PIT_ROLES.ProcessingIncharge  ) {
            data = {
                "consignmentStatus": searchFilter?.consignmentStatus ? searchFilter?.consignmentStatus : null,
                "schduledDeliveryDate": searchFilter?.schduledDeliveryDate ? searchFilter?.schduledDeliveryDate : null
            }
        }



        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader()
        apiClient
            .post(GET_ASN_LIST, data, { headers })
            .then(res => setAsnDetails(res.data.asnList))
            .catch(function(err) {
                console.log(err);
                toast.error(err.message);
            });
        loaderService.hideLoader();
    };

    const handleChange = (e) => {
        if (e.target.name === "consignmentStatus" || e.target.name === "schduledDeliveryDate") {
            setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
        }
    }
    function searchAsnDetails(e) {
        e.preventDefault();
        getAsnDetails();
    }

    const columns = [
        { field: 'asnNo', headerName: 'ASN ID#', width: 200 },
        { field: 'consignmentNo', headerName: 'Consignment#', width: 200 },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 200 },
        { field: 'asnType', headerName: 'Material Type', width: 200 },
        {
            field: 'schduledDeliveryDate', headerName: 'Scheduled Delivery Date ', width: 200,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        {
            field: 'Action', width: 120,
            renderCell: (cellValues) => {
                return (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onViewDetails(cellValues)}
                    >
                        View
                    </Button>
                );
            }
        },
    ];

    return (
        <div>
            <Container fluid>
                <Row>
                    <Col xs={12} md={12}>
                        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT14</p>}
                        <div>
                            <form>
                                <div className="headingStylePIT">ASN Details</div>
                                <div className="asn-header-search-field">
                                    <label style={{ marginTop: "1vh" }}>Consignment Status: </label>
                                    <select className='ght-dropdown' name="consignmentStatus" value={searchFilter.consignmentStatus} onChange={(e) => handleChange(e)}>
                                        <option value="">Select</option>
                                        {consignmentStatusList &&
                                            consignmentStatusList.map((status) => (
                                                <option value={status}>{status}</option>
                                            ))}

                                    </select>
                                    <label style={{ marginTop: "1vh", marginLeft: "1vw" }}>Scheduled Delivery Date: </label>
                                    <input className='ght-dropdown' type="date" name="schduledDeliveryDate" value={searchFilter.schduledDeliveryDate} onChange={(e) => handleChange(e)}></input>
                                    <button style={{ border: "0.2vh solid #000000", height: "6vh", borderRadius: "1vh" }} onClick={(e) => searchAsnDetails(e)}>
                                        <SearchIcon />
                                    </button>
                                </div>
                                <Card>
                                    <Box style={{ height: 500, width: '100%' }}>
                                        {
                                            asnDetails &&
                                            <DataGrid rows={asnDetails}
                                                columns={columns}
                                                pageSize={10}
                                                components={{ Toolbar: QuickSearchToolbar }}
                                            />
                                        }

                                    </Box>
                                </Card>
                                {/* <div className='common-table-div'>
                                <Table responsive className="common-table" striped>
                                    <>
                                        <thead>
                                            <tr>
                                                <th className='common-table-heading-text'>ASN ID#</th>
                                                <th className='common-table-heading-text'>Consignment #</th>

                                                <th className='common-table-heading-text'>Consignment Status  </th>
                                                <th className='common-table-heading-text'>Scheduled Delivery Date </th>

                                                <th className='common-table-heading-text'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {asnDetails?.map(row =>
                                                        <tr>
                                                        <td className='common-table-text'>{row.asnNo}</td>
                                                        <td className='common-table-text'>{row.consignmentNo}</td>
                                                        <td className='common-table-text'>{row.consignmentStatus}</td>
                                                        <td className='common-table-text'>{row.schduledDeliveryDate && Moment(row.schduledDeliveryDate).format('DD/MM/YYYY')}</td>
                                                        <td><input type="button" className="verify-btn-vehicleEntry-details" value="View" onClick={() => onViewDetails(row)} /></td>
                                                    </tr>
                                                    )}
                                            
                                        </tbody>
                                    </>
                                </Table>
                            </div> */}
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
export default AsnGRNChipping;
